import React, { useEffect, useState } from "react";
import avatar from "../Assets/imgs/avatar.webp";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { getCookie, onpressLogoutBtn } from "../utils/Common";
import { Link, useLocation } from "react-router-dom";
import { pageTitleKey } from "../utils/pageMeta";

const TopBar = () => {
  const [userName, setUserName] = useState<string>("");
  const { t, i18n } = useTranslation(); // ✅ Hook used inside the component
  const { pathname } = useLocation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng); // ✅ This now works
  };

  useEffect(() => {
    // Get user data from cookie
    const cookie: any = getCookie("data");
    if (cookie) {
      try {
        console.log("cookie data:", cookie);
        setUserName(cookie?.name || "User");
      } catch (err) {
        console.error("Invalid cookie data:", err);
      }
    }
  }, []);
  const handleMenuClick = () => {
    window.dispatchEvent(new Event("toggleSidebar"));
  };
  return (
    <>
      <div className="__topBar b-shadow">
        <div className="flex">
          <div>
            <div className="__topHeading">{t(pageTitleKey(pathname))}</div>
            <button type="button" className="menubar aces-icon-btn" onClick={handleMenuClick} aria-label={t("aces.a11y.toggleMenu")}>
              <i className="ri-menu-line" aria-hidden="true"></i>
            </button>
          </div>

          <div className="__TopRightSide flex-gap">
            {/* <div className="__searchInput">
              <input type="text" placeholder="search" />
              <i className="ri-search-line"></i>
            </div> */}
            <div className="language-switcher">
              <select
                aria-label={t("aces.a11y.language")}
                value={i18n.language}
                onChange={(e) => i18n.changeLanguage(e.target.value)}
              >
                <option value="en">English</option>
                <option value="fr">Français</option>
                <option value="nl">Nederlands</option>
                <option value="de">Deutsch</option>
                <option value="sp">Español</option>
                <option value="it">Italiano</option>
                <option value="pt">Português</option>
              </select>
              <div className="arrow__down__icon">
                <i className="ri-arrow-down-s-line"></i>
              </div>
            </div>

            <Link to="/notification" className="__notificationBar flex-cemter" aria-label={t("aces.nav.notifications")}>
              <i className="ri-notification-line" aria-hidden="true"></i>
            </Link>

            <Dropdown>
              <Dropdown.Toggle
                as="div"
                className="__userProfile flex-gap"
                id="dropdown-custom-components"
              >
                <div className="__avatar flex-cemter">
                  <img src={avatar} alt="avatar" />
                </div>
                <div className="__userName">
                  {userName || "User"} <i className="ri-arrow-down-s-line"></i>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="userProfilemenu">
                <Dropdown.Item as={Link} to="/profile">
                  <div className="flex-gap">
                    <i className="ri-user-line"></i>
                    {t("menu.my_profile")}
                  </div>
                </Dropdown.Item>
                <div className="support-section px-3 py-2">
                  <div
                    className="support-title mb-2"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    {t("menu.support")}
                  </div>
                  <div className="flex-gap mb-2">
                    <i className="ri-mail-line"></i>
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to=qualicheck-support@logic-services.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                      style={{ color: "#000" }}
                    >
                      qualicheck-support@logic-services.com
                    </a>
                  </div>
                  <div className="flex-gap">
                    <i className="ri-whatsapp-line"></i>
                    <a
                      href="https://wa.me/32492958159"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                      style={{ color: "#000" }}
                    >
                      +32 492 95 81 59
                    </a>
                  </div>
                </div>
                <div
                  style={{
                    height: "1px",
                    backgroundColor: "lightgrey",
                    margin: "8px 0",
                    width: "100%",
                  }}
                ></div>

                <Dropdown.Item>
                  <div className="flex-gap" onClick={() => onpressLogoutBtn()}>
                    <i className="ri-logout-box-r-line"></i>
                    {t("menu.logout")}
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
